import { render, staticRenderFns } from "./MyPreferences.container.vue?vue&type=template&id=708362c3&scoped=true&"
import script from "./MyPreferences.container.vue?vue&type=script&lang=ts&"
export * from "./MyPreferences.container.vue?vue&type=script&lang=ts&"
import style0 from "./MyPreferences.container.vue?vue&type=style&index=0&id=708362c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708362c3",
  null
  
)

export default component.exports